<template>
  <div>
    <a-row class="mb-20" style="margin-bottom: 20px">
      <a-col :xs="24" :sm="24" :md="8">
        <a-input-search
          style="width: 100%"
          :placeholder="$t('feedpostManager.search')"
          enter-button
          @search="onSearch"
        />
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 4, offset: 1}">
        <a-select
          style="width: 100%"
          :v-decorator="['cat_id']"
          :allow-clear="true"
          :placeholder="$t('feedpostManager.selectFeed')"
        >
          <template v-show="feeds && feeds.length > 0">
            <a-select-option v-for="feed in feeds" :key="feed.id">
              {{ feed.name }}
            </a-select-option>
          </template>
        </a-select>
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 2, offset: 8}">
        <a-button type="primary" icon="plus" @click="handleCreate">
          {{ $t('table.create') }}
        </a-button>
      </a-col>
    </a-row>
    <a-divider />
    <a-row>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="record">
          <a-button type="primary" icon="form" size="small" @click="handleEdit(record)">{{ $t('table.update') }}</a-button>
          <a-divider type="vertical" />
          <a-button type="danger" icon="delete" size="small" @click="confirmDelete(record)">{{ $t('table.delete') }}</a-button>
        </span>
      </a-table>
    </a-row>
    <AddEditModal ref="refModal" @updateFeedPostSuccess="handleUpdateFeedPostSuccess" />
  </div>
</template>

<script>
import {
  SearchFeedPost as ApiSearchFeedPost,
  DestroyFeedPost as ApiDestroyFeedPost
} from '@/api/feedposts';
import AddEditModal from './AddEditModal.vue';
import { SearchFeed as ApiSearchFeed } from '@/api/feeds';

export default {
  name: 'FeedPost',
  components: {
    AddEditModal
  },
  data() {
    const columns = [
      {
        dataIndex: 'cat_name',
        title: () => this.$t('feedpostManager.column.cat_name'),
        key: 'cat_name'
      },
      {
        dataIndex: 'name',
        title: () => this.$t('feedpostManager.column.name'),
        key: 'name'
      },
      {
        dataIndex: 'icon',
        title: () => this.$t('feedpostManager.column.icon'),
        key: 'icon'
      },
      {
        title: this.$t('table.action'),
        key: 'action',
        width: '200px',
        scopedSlots: { customRender: 'action' }
      }
    ];
    return {
      columns,
      data: [],
      feeds: [],
      pagination: { current: 1, pageSize: 15 },
      filter: {},
      params: {},
      loading: false,
      form: this.$form.createForm(this)
    };
  },
  created() {
    this.handleSearch();
    this.getFeeds();
  },
  methods: {
    onSearch(value) {
      this.filter.name = value;
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.params.filter = this.filter || {};
      this.params.page = this.pagination.current || 1;
      ApiSearchFeedPost(this.params)
        .then((response) => {
          const { data, pagination } = response;
          this.data = data;
          this.pagination = {
            total: pagination.total,
            pageSize: pagination.perPage,
            current: pagination.currentPage
          };
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.handleSearch();
    },
    handleCreate() {
      this.$refs.refModal.showModal();
    },
    handleEdit(row) {
      this.$refs.refModal.showModal(row.id);
    },
    handleUpdateFeedPostSuccess() {
      this.handleSearch();
    },
    confirmDelete(record) {
      this.$confirm({
        title: this.$t('modal.confirmDelete.question'),
        okText: this.$t('modal.confirmDelete.ok'),
        cancelText: this.$t('modal.confirmDelete.cancel'),
        onOk: () => {
          const { id } = record;
          ApiDestroyFeedPost({ id })
            .then(() => {
              this.$notification.success({ message: this.$t('modal.successMessage.deleteSuccess') });
              this.searchFeedPost();
            })
            .catch(() => {
              this.$notification.error({ message: this.$t('modal.faildMessage.deleteFaild') });
            });
        }
      });
    },
    getFeeds() {
      this.loading = true;
      ApiSearchFeed()
        .then((response) => {
          const { data } = response;
          this.feeds = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>
